import { Message } from 'dg-web-shared/lib/Localized';
import { ParkingaboZoneInfo } from '../../../shared/ParkingaboProductModels';
import { VehicleLicensePlateType } from 'dg-web-shared/common/models/Vehicle';
import { SubscriptionIntervalDuration } from 'product-shared/product-template/SubscriptionIntervalDuration';
import { ZoneType } from 'dg-web-shared/dto/ZoneType.ts';
import { ParkingaboProductType } from 'product-shared/product-template/ParkingaboProductType.ts';
import { SubscriptionProRataConfig } from 'product-shared/product-template/SubscriptionIntervalConfig.ts';

export type ParkingaboProductTemplate =
    | ParkingaboProductTemplateReservation
    | ParkingaboProductTemplateSubscription
    | ParkingaboProductTemplateGuestReservationUbs;

interface ParkingaboProductTemplateBase {
    type: ParkingaboProductType;
    contractTemplateId: number;
    name: Message;
    vehicleTypes: VehicleLicensePlateType[];
    zoneIds: number[];
    info?: Message;
}

export enum ReservationTimeAndPriceConfigType {
    CALENDAR_DAY = 'CALENDAR_DAY',
}

export interface WeekdayPrice {
    mondayRappen: number | null;
    tuesdayRappen: number | null;
    wednesdayRappen: number | null;
    thursdayRappen: number | null;
    fridayRappen: number | null;
    saturdayRappen: number | null;
    sundayRappen: number | null;
}

export interface ReservationTimeACalendarDayReservationTimeAndPrice {
    type: ReservationTimeAndPriceConfigType.CALENDAR_DAY;
    validityStart: string;
    validityEnd: string;
    maxPurchaseQuantity: number;
    maxDaysPurchaseAheadInFuture: number;
    minValidityStart: string | null;
    maxValidityEnd: string | null;
    priceConfig: WeekdayPrice;
}

export type DayAndPriceConfig =
    ReservationTimeACalendarDayReservationTimeAndPrice;

export interface ParkingaboProductTemplateReservation extends ParkingaboProductTemplateBase {
    type: ParkingaboProductType.RESERVATION;
    dayAndPriceConfig: DayAndPriceConfig;
}

export interface ParkingaboProductTemplateGuestReservationUbs extends ParkingaboProductTemplateBase {
    type: ParkingaboProductType.GUEST_RESERVATION_UBS;
    appPurchaseDisclaimerText: Message;
    appPurchaseCustomerRemarkLabel: Message | null;
    maxHours: number;
    maxDaysPurchaseAheadInFuture: number;
    minValidityStart: string | null;
    maxValidityEnd: string | null;
}

export interface ParkingaboProductTemplateSubscription extends ParkingaboProductTemplateBase {
    type: ParkingaboProductType.SUBSCRIPTION;
    intervalConfig: SubscriptionIntervalConfig;
}

export function formatZoneName(zone: ParkingaboZoneInfo): string {
    if (zone.zoneType === ZoneType.enforced) {
        return [zone.extZoneCode, zone.name, zone.city].join(' – ');
    }
    return [zone.name, zone.city].join(' – ');
}

export interface SubscriptionIntervalConfig {
    maxIntervalsPurchaseAheadInFuture: number;
    intervalPriceRappen: number;
    intervalDuration: SubscriptionIntervalDuration;
    subscriptionProRataConfig: SubscriptionProRataConfig;
    proRataUntilEndOfMonthPrice: number | null;
}
